import React, { useState } from 'react';
import '../styles/NewsFeedTile.css';
import { useAuth } from '../context/AuthContext';
import Modal from './Modal';

const NewsFeedTile = ({ update, onDelete, apiBaseUrl }) => {
  const { title, description, image, date, importance, media_id, icon, id } = update;
  const { userRoles, isAuthenticated } = useAuth();
  const [modal, setModal] = useState({ isOpen: false, title: '', message: '', buttons: [] });

  const isAdmin = isAuthenticated && userRoles.includes('admin');
  const tileClass = `newsfeed-tile ${importance === 'big' ? 'newsfeed-big' : importance === 'medium' ? 'newsfeed-medium' : 'newsfeed-small'}`;

  const showModal = (title, message, buttons) => {
    setModal({ isOpen: true, title, message, buttons });
  };

  const closeModal = () => setModal({ ...modal, isOpen: false });

  const confirmDelete = () => {
    showModal(
      'Delete Update?',
      `Are you absolutely sure you want to delete "${title}"? This cannot be undone.`,
      [
        {
          label: 'Yes, delete it',
          class: 'btn btn-danger',
          action: async () => {
            await handleDelete();
            // closeModal();
          },
        },
        {
          label: 'Cancel',
          class: 'btn btn-secondary',
          action: closeModal,
        },
      ]
    );
  };

  const handleDelete = async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/newsfeed/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (res.ok) {
        if (onDelete) onDelete(id);
        showModal(
          'Delete Successful',
          `"${title}" has been deleted.`,
          [
            {
              label: 'Okay',
              // class: 'btn btn-danger',
              action: async () => {
                closeModal();
              }
            }
          ]
        )
      } else {
        alert('Failed to delete newsfeed update.');
        console.error(await res.text());
      }
    } catch (err) {
      console.error(err);
      alert('Error deleting newsfeed update.');
    }
  };

  return (
    <>
      <div className={tileClass} style={importance === 'big' && image ? { backgroundImage: `url(${image})` } : {}}>
        {isAdmin && (
          <div className="newsfeed-delete-icon" onClick={(e) => { e.stopPropagation(); confirmDelete(); }}>
            <img
              src="/static/icons/trash-solid.svg"
              alt="Delete"
              className="icon-svg"
              title="Delete Update"
            /> 
          </div>
        )}

        {importance === 'big' && image && (
          <>
            <div className="newsfeed-poster">
              <img src={image} alt={title} />
            </div>
            <div style={{ minHeight: "160px", minWidth: "180px", backdropFilter: "blur(30px)" }}></div>
          </>
        )}
        {importance === 'medium' && image && (
          <div className="newsfeed-image">
            <img src={image} alt={title} />
          </div>
        )}
        {importance === 'small' && image && (
          <div className="newsfeed-poster">
            <img src={image} alt={title} />
          </div>
        )}

        <div className="newsfeed-content">
          <div className="newsfeed-date">
            {new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </div>

          <h3>{title}</h3>
          <p className="newsfeed-description">{description}</p>

          {media_id && (
            <a
              href={`/media-item/${media_id}`}
              className="newsfeed-media-link"
              onClick={e => e.stopPropagation()}
            >
              View Media
              <img src="/static/icons/arrow-right-solid.svg" className="arrow-icon" alt="Arrow" />
            </a>
          )}
        </div>
      </div>

      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
        buttons={modal.buttons}
      />
    </>
  );
};

export default NewsFeedTile;
